var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { More } from "iconsax-react";
import { useDispatch } from "react-redux";
import { resetSelectedUserRow } from "@reducers/users/slice/user-slice";
import { deleteUser } from "@reducers/users/thunk/user-thunk";
import { toast } from "@ui/utils/toaster";
export const useUsersActions = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation(["form", "validation", "common"]);
    // Navigation actions
    const handleAddUser = () => {
        dispatch(resetSelectedUserRow()); // Clear any selected user data for new user
        navigate("/users/new");
    };
    const handleEditUser = (userId) => {
        navigate(`/users/${userId}`);
    };
    const handleViewUser = (userId) => {
        // Navigate to user profile page
        navigate(`/users/${userId}/profile`);
    };
    const handleDeleteUser = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        yield dispatch(deleteUser(userId))
            .unwrap()
            .then(() => {
            toast.success(t("common:toasts.userDeletedSuccessfully"));
        })
            .catch(() => {
            toast.error(t("common:toasts.failedToDeleteUser"));
        });
    });
    // User management actions
    const handleBulkDelete = (userIds) => { };
    const handleExportUsers = () => { };
    const handleImportUsers = () => { };
    // Page header action button configuration
    const getPageHeaderActions = () => ({
        label: t("common:actions.addUser"),
        onClick: handleAddUser,
        variant: "contained",
        size: "large",
        startIcon: React.createElement(More, { size: 20 }),
    });
    // Individual user action handlers
    const getUserActions = (user) => ({
        edit: () => handleEditUser(user.id),
        view: () => handleViewUser(user.id),
        delete: () => handleDeleteUser(user.id),
    });
    return {
        // Navigation actions
        handleAddUser,
        handleEditUser,
        handleViewUser,
        handleDeleteUser,
        // Bulk actions
        handleBulkDelete,
        handleExportUsers,
        handleImportUsers,
        // Action configurations
        getPageHeaderActions,
        getUserActions,
    };
};
